import { render, staticRenderFns } from "./CardSingleLayout.vue?vue&type=template&id=05169c28&scoped=true"
import script from "./CardSingleLayout.vue?vue&type=script&lang=js"
export * from "./CardSingleLayout.vue?vue&type=script&lang=js"
import style0 from "./CardSingleLayout.vue?vue&type=style&index=0&id=05169c28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05169c28",
  null
  
)

export default component.exports